import { render } from "./CadastrarCategoriaNegocio.vue?vue&type=template&id=3b205c7e&scoped=true"
import script from "./CadastrarCategoriaNegocio.vue?vue&type=script&lang=js"
export * from "./CadastrarCategoriaNegocio.vue?vue&type=script&lang=js"

import "./CadastrarCategoriaNegocio.vue?vue&type=style&index=0&id=3b205c7e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\marce\\OneDrive\\Área de Trabalho\\Nova pasta (4)\\NoroesteRural 10.25.13\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b205c7e"]])

export default __exports__